const DISCLAIMER_RE = /guidance only.*agronomist/i;

function parseListLine(line) {
  const match = String(line).match(/^\s*[-*•]\s+(.+)$/);
  return match ? match[1].trim() : null;
}

function splitInlineBold(text) {
  const parts = [];
  const re = /\*\*([^*]+)\*\*/g;
  let last = 0;
  let match;
  while ((match = re.exec(text)) !== null) {
    if (match.index > last) parts.push({ type: "text", value: text.slice(last, match.index) });
    parts.push({ type: "bold", value: match[1] });
    last = match.index + match[0].length;
  }
  if (last < text.length) parts.push({ type: "text", value: text.slice(last) });
  return parts.length ? parts : [{ type: "text", value: text }];
}

export function parseAgentMessage(content) {
  const text = String(content || "").trim();
  if (!text) return { blocks: [], disclaimer: "" };

  const lines = text.split("\n");
  const blocks = [];
  let currentTitle = "";
  let buffer = [];
  let disclaimer = "";

  function flush() {
    const body = buffer.join("\n").trim();
    buffer = [];

    if (!body && !currentTitle) return;

    const listItems = [];
    const paragraphs = [];

    body.split("\n").forEach((line) => {
      const trimmed = line.trim();
      if (!trimmed) return;
      if (DISCLAIMER_RE.test(trimmed)) {
        disclaimer = trimmed;
        return;
      }
      const listItem = parseListLine(trimmed);
      if (listItem) listItems.push(splitInlineBold(listItem));
      else paragraphs.push(splitInlineBold(trimmed));
    });

    if (currentTitle) {
      blocks.push({
        type: "section",
        title: currentTitle,
        listItems,
        paragraphs,
      });
    } else if (paragraphs.length || listItems.length) {
      blocks.push({ type: "text", paragraphs, listItems });
    }
  }

  lines.forEach((line) => {
    const sectionMatch = line.match(/^\*\*([^*]+)\*\*:?\s*(.*)$/);
    if (sectionMatch) {
      flush();
      currentTitle = sectionMatch[1].trim();
      if (sectionMatch[2].trim()) buffer.push(sectionMatch[2].trim());
      return;
    }
    buffer.push(line);
  });

  flush();

  if (!blocks.length) {
    blocks.push({ type: "text", paragraphs: [splitInlineBold(text)], listItems: [] });
  }

  return { blocks, disclaimer };
}

export function isPlantScanContent(content) {
  return /^\*\*Plant:\*\*/im.test(String(content || ""));
}
